import React, { useEffect } from 'react';
import {
  BrowserRouter,
  Route,
  Routes,
  useLocation,
} from 'react-router-dom';

import LegalPage from './components/LegalPage';
import SupportPage from './components/SupportPage';
import DownloadPage from './components/DownloadPage';
import GuidedLandingPage from './marketing/GuidedLandingPage';

/**
 * Restores the document scroll position when the route path changes.
 *
 * @returns {null} This routing helper does not render visible content.
 * @sideEffects Scrolls the browser window to the document origin.
 */
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

/**
 * Renders route content inside BrowserRouter and resets document scroll on
 * navigation. It accepts no inputs and returns the public site route tree.
 *
 * @returns {React.ReactElement} Routed marketing, legal, privacy, or support content.
 * @sideEffects Delegates route-change scrolling to ScrollToTop.
 */
function AppContent() {
  const privacyPage = (
    <main className="document-route">
      <LegalPage type="privacy" />
    </main>
  );

  return (
    <div className="site-shell">
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<GuidedLandingPage />} />
        <Route
          path="/tnc"
          element={<main className="document-route"><LegalPage type="tnc" /></main>}
        />
        <Route path="/privacy-policy" element={privacyPage} />
        <Route path="/privacy" element={privacyPage} />
        <Route
          path="/support"
          element={<main className="document-route"><SupportPage /></main>}
        />
        <Route
          path="/download"
          element={<main className="document-route"><DownloadPage /></main>}
        />
      </Routes>
    </div>
  );
}

/**
 * Provides BrowserRouter context for the Milan public website.
 *
 * @returns {React.ReactElement} The routed website application.
 * @sideEffects Subscribes React Router to browser history.
 */
function App() {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}

export default App;
